(() => {
  const fold = value => value.toLocaleLowerCase('az').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ə/g, 'e').replace(/ı/g, 'i');
  const search = document.querySelector('#fx-route-search');
  if (search) {
    const rows = [...document.querySelectorAll('[data-fx-route-search]')];
    const groups = [...document.querySelectorAll('.fx-route-region')];
    const count = document.querySelector('[data-fx-route-count]');
    const empty = document.querySelector('[data-fx-route-empty]');
    const data = rows.map(row => ({row, text:fold(row.dataset.fxRouteSearch)}));
    search.addEventListener('input', () => {
      const terms = fold(search.value).trim().split(/\s+/).filter(Boolean);
      let matches = 0;
      for (const entry of data) { entry.row.hidden = !terms.every(term => entry.text.includes(term)); if (!entry.row.hidden) matches++; }
      for (const group of groups) {
        const visible = group.querySelectorAll('li:not([hidden])').length;
        group.hidden = visible === 0;
        group.querySelector('summary span').textContent = `${visible} şəhər`;
        if (terms.length) group.open = true;
      }
      count.textContent = `${matches} uyğun istiqamət`;
      empty.hidden = matches !== 0;
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-fx-route-airport]');
    if (!button) return;
    const article = button.closest('article');
    const input = article?.querySelector('[name="destination"]');
    if (!input) return;
    input.value = button.dataset.fxRouteAirport;
    input.dispatchEvent(new Event('input', {bubbles:true}));
    input.dataset.airportValue = input.value;
    input.dataset.airportCountry = button.dataset.fxCountry;
    const form = article.querySelector('[data-fx-form]');
    form.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    article.querySelector('.fx-date-control')?.focus({preventScroll:true});
  });
})();
